import React, { Component } from 'react'
import Switch  from "react-switch";

export default class Toggle extends Component {
    render() {
        return (
            <div
                style={{
                    float: "right",
                    verticalAlign: "middle",
                    marginRight: "10px"
                }}
            >
                <Switch
                    className="switch"
                    checked={this.props.checked}
                    onChange={this.props.handleChange}
                    name="checked"
                    disabled={this.props.disabled}
                />
            </div>
        )
    }
}
